/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import InActionsTravels from "./InActionsTravels";
import InActionsTravelsTrucks from "./InActionsTravelsTrucks";
import { useHistory, useLocation } from "react-router-dom";
import TripDetails from "./TripDetails/index";
import queryString from "query-string";
import { getTripsTcCreatedByStateAPI } from "../../../../../api/modules";

const Index = ({ trips, state }) => {
  const history = useHistory();
  const location = useLocation();
  const [tripId, setTripId] = useState(null);
  const [detailTrip, setDetailTrip] = useState(false);


  useEffect(() => {
    const { tripId, detailTrip } = queryString.parse(location.search);
    setTripId(tripId);
    setDetailTrip(detailTrip);
  }, [location]);



  const getScreen =
    tripId && detailTrip ? (
      <TripDetails detailTrip={detailTrip} tripId={tripId} />
    ) : tripId ? (
      <InActionsTravelsTrucks tripId={tripId} />
    ) : (
      <InActionsTravels/>
    );

  return <div>{getScreen} </div>;
};

Index.propTypes = {};

export default Index;
